import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { createPinia } from "pinia";
import mitt from "mitt";
const Emitter = mitt();

import "@fortawesome/fontawesome-free/css/all.min.css";
import "vuetify/styles";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import "@mdi/font/css/materialdesignicons.css";

// swiper use
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import "swiper/swiper-bundle.min.css";

const vuetify = createVuetify({
  components,
  directives,
});

createApp(App)
  .use(createPinia())
  .use(vuetify)
  .provide("Emitter", Emitter)
  .use(router)
  .mount("#app");
